<template>
  <BaseDialog isOpen>
    <template v-slot:title>
      Are you sure you want to request reference details from the candidate?
    </template>
    <template v-slot:body>
      <div class="secondary-text">
        This will ask the candidate to provide reference details
      </div>
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="cancel" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
          Request Details
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { OFFERS_NAMESPACE } from "@/store/modules/offers";
import { REQUEST_OFFER_REFERENCES } from "@/store/modules/offers/actions";

const { mapActions } = createNamespacedHelpers(OFFERS_NAMESPACE);

export default {
  name: "RequestReferencesDialog",
  components: { PrimaryButton, BaseDialog },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    currentOfferId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      requestOfferReferences: REQUEST_OFFER_REFERENCES
    }),
    async handleSubmit() {
      this.isLoading = true;
      await this.requestOfferReferences(this.currentOfferId);
      this.cancel();
      this.isLoading = false;
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
